<div class="modal-header">
  <h4 class="modal-title">{{ documentName | async }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

  <p class="alert alert-warning" *ngIf="error">{{ error }}</p>

  <form id="payment-form">
    <div id="payment-element" #cardInfo>
      <!--Stripe.js injects the Payment Element-->
    </div>
  </form>

</div>
<div class="modal-footer">
  <button [disabled]="loading" type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">{{ 'Cancel' | translate }}</button>
  <button [disabled]="loading" class="btn btn-primary ml-auto" (click)="onPay()">{{ 'Pay' | translate }} <i *ngIf="loading" class="fa fa-spinner fa-spin ml-2"></i></button>
</div>
